import TYPE from '../actions/TYPE';

const initialState = {
  list: {},
  detail: {}
};

const topic = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.LIST_TOPIC_SUCCESS:
      return {
        ...state,
        list: action.data
      };
    default:
      return state;
  }
};

export default topic;
